import { Component } from '@angular/core';
import { MetaDataService } from '../metadata.service';

@Component({
  selector: 'tea-shop-fe-refunds-policy',
  standalone: false,
  
  templateUrl: './refunds-policy.component.html',
  styleUrl: './refunds-policy.component.css'
})
export class RefundsPolicyComponent {

  constructor(
    private metaDataService: MetaDataService
  ) { 
    this.metaDataService.updateMetadata({
      title: 'Refunds Policy',
      image: '/assets/contact/sencha-logo.png',
    });
  }
}
